<template>
  <!-- -->
  <div class="gantt" :style="{'--plan-color': color[0], '--plan-color-hover': color[1], '--actuality-color': color[2], '--actuality-color-hover': color[3], height: height}">
    <yq-table v-if="showTable" :data="data" :height="height" row-key="id" :default-expand-all="true">
      <slot />
      <el-table-column label="执行计划" min-width="800rem">
        <template #header>
          <div class="title" id="gant-title-header">{{ gantTitle }}</div>
          <div class="title-info">
            <div class="title-info-item">{{timeMax.minTime}}</div>
            <div class="title-info-item">{{timeMax.maxTime}}</div>
          </div>
        </template>
        <template v-slot="{row, $index}">
          <div v-if="row.gantData.plan && row.gantData.plan.length > 0" class="gant-plan">
            <el-popover v-for="(item, index) in row.gantData.plan" :key="index" placement="top-start" :title="item.title || '计划时间'" width="10rem" trigger="hover" :content="`${item.startTime}至${item.endTime}`">
              <template #reference>
                <div class="gant-item" :style="{'left': item.start * 100 + '%', 'width': item.length + '%'}"></div>
              </template>
            </el-popover>
          </div>
          <div v-if="row.gantData.actuality && row.gantData.actuality.length > 0" class="gant-actuality">
            <el-popover v-for="(item, index) in row.gantData.actuality" :key="index" placement="top-start" :title="item.title || '实际时间'" width="10rem" trigger="hover" :content="`${item.startTime}至${item.endTime}`">
              <template #reference>
                <div class="gant-item" :style="{'left': item.start * 100 + '%', 'width': item.length + '%'}"></div>
              </template>
            </el-popover>
          </div>
        </template>
      </el-table-column>
    </yq-table>
  </div>
</template>

<script>

import YqTable from "@/components/h5/table/YqTable.vue";
import {watch} from "vue";

export default {
  props: {
    data: {
      type: Array,
      default: []
    },
    ganttConfig: {
      type: Object,
      default: {
        planDate: 'planDate', // 计划时间，时间格式 yyyy-MM-dd - yyyy-MM-dd,时间中间要加空格,也可以用数组或obj数组，obj数组的格式为：[{time, title}]
        actualityDate: 'actualityDate', // 实际时间
        planColor: '#32cd32', // 颜色，只支持16进制颜色
        planColorHover: '#32cd32',
        actualityColor: '#f2f215', // 颜色，只支持16进制颜色
        actualityColorHover: '#409eff',
      }
    },
    height: {default: "auto"},
    gantTitle: {default: "执行计划"}, // 甘特图的名称
  },
  name: "",
  components: {
    YqTable
  },
  data() {
    return {
      timeMax: {
      }, // 时间范围
      color: [], // 颜色
      showTable: true,
    };
  },
  created() {
    // 初始化颜色
    this.color = [
        this.ganttConfig.planColor || "var(--el-color-success)",
        this.ganttConfig.planColorHover || "var(--el-color-success-light-3)",
        this.ganttConfig.actualityColor || "var(--el-color-primary)",
        this.ganttConfig.actualityColorHover || "var(--el-color-primary-light-3)",
    ]
    this.init();
    watch(() => this.data, () => this.init());
  },
  mounted() {
  },
  methods: {
    // 初始化数据
    init() {
      // 计算最大，最小时间
      let timeMax = {
        min: 0,
        max: 0,
      };
      for (let i = 0; i < this.data.length; i++) {
        this.getDateTimeMax(this.data[i][this.ganttConfig.planDate], timeMax);
        this.getDateTimeMax(this.data[i][this.ganttConfig.actualityDate], timeMax);
      }
      this.timeMax = {
        min: timeMax.min,
        max: timeMax.max,
        minTime: new Date(timeMax.min).format("yyyy-MM-dd"),
        maxTime: new Date(timeMax.max).format("yyyy-MM-dd")
      }
      // 给最大最小时间，增加左右余量
      this.getGantData(this.data, timeMax);
      this.showTable = false;
      this.$nextTick().then(() => this.showTable = true);
    },
    getGantData(list, timeMax) {
      for (let i = 0; i < list.length; i++) {
        // 添加甘特图数据
        list[i].gantData = {
          plan: this.getDateTimes(list[i][this.ganttConfig.planDate], timeMax),
          actuality: this.getDateTimes(list[i][this.ganttConfig.actualityDate], timeMax),
        };
        if (list[i].children && list[i].children.length > 0) {
          this.getGantData(list[i].children, timeMax);
        }
      }
    },
    // 获取总的时间
    getDateTimeMax(dateTime, timeMax) {
      if (typeof dateTime === "string") {
        // 是字符串
        let dateArray = dateTime.split(" - ");
        if (dateArray.length === 2) {
          let startTime = new Date(dateArray[0] + " 00:00:00");
          let endTime = new Date(dateArray[1] + " 23:59:59");
          if (startTime.getTime() < timeMax.min || timeMax.min === 0) {
            timeMax.min = startTime.getTime();
          }
          if (endTime.getTime() > timeMax.max || timeMax.max === 0) {
            timeMax.max = endTime.getTime();
          }
        }
      } else if (dateTime instanceof Array) {
        // 是数组，数组有可能里面是对象，也有可能是字符串
        for (let i = 0; i < dateTime.length; i++) {
          if (typeof dateTime[i] === "string") {
            this.getDateTimeMax(dateTime[i], timeMax);
          } else if (typeof dateTime[i] === "object") {
            // 是对象
            this.getDateTimeMax(dateTime[i].time, timeMax);
          }
        }
      }
    },
    // 获取时间，根据总时间，计算出占据的百分比，由于可能有多个时间，给出一个数组
    getDateTimes(dateTime, timeMax) {
      if (typeof dateTime === "string") {
        let result = this.getDateTimes2(dateTime, timeMax);
        return result ? [result] : [];
      } else if (dateTime instanceof Array) {
        let arr = [];
        for (let i = 0; i < dateTime.length; i++) {
          let item = null;
          if (typeof dateTime[i] === "string") {
            item = this.getDateTimes2(dateTime[i], timeMax);
          } else if (typeof dateTime[i] === "object") {
            item = this.getDateTimes3(dateTime[i], timeMax);
          }
          if (item && item.startTime) {
            arr.push(item);
          }
        }
        return arr;
      }
      return [];
    },
    getDateTimes3(dateTime, timeMax) {
      let d = dateTime.time;
      let data = this.getDateTimes2(d, timeMax);
      if (data) {
        data.title = dateTime.title;
        return data;
      }
      return null;
    },
    getDateTimes2(dateTime, timeMax) {
      if (!dateTime || typeof dateTime !== "string") return null;
      let dateArray = dateTime.split(" - ");
      if (dateArray.length === 2) {
        let startTime = new Date(dateArray[0] + " 00:00:00");
        let endTime = new Date(dateArray[1] + " 23:59:59");
        let length = timeMax.max - timeMax.min;
        let thisLength = endTime.getTime() - startTime.getTime();
        return {
          start: (startTime.getTime() - timeMax.min) / length,
          length: (thisLength / length * 100),
          startTime: dateArray[0],
          endTime: dateArray[1],
        };
      }
      return null;
    }
  }
};
</script>

<style lang="scss" scoped>
.gant-plan{
  position: relative;
  --bg-color: var(--plan-color);
  --bg-color-hover: var(--plan-color-hover);
  height: 15px;
}
.gant-actuality{
  position: relative;
  --bg-color: var(--actuality-color);
  --bg-color-hover: var(--actuality-color-hover);
  height: 15px;
}
.gant-item{
  position: absolute;
  background: var(--bg-color);
  height: 100%;
}
.gant-item:hover{
  background: var(--bg-color-hover);
}
.title-info{
  border-top: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
  .title-info-item{

  }
}
.title{
  text-align: center;
}
</style>